import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Alert from './Alert';
import LoadingScreen from './LoadingScreen';


export default function UpdateEmail({userData}) {
 const [cookies, setCookie] = useCookies(['accessToken']);
 const navigate = useNavigate();
 const [isLoading, setIsLoading] = useState(false);
 const [alertActive, setAlertActive] = useState(true);
 const [alert, setAlert] = useState({});
 const [newEmail, setNewEmail] = useState(' ');
 const [otp, setOtp] = useState(' ');
 const [otpToken, setOtpToken] = useState('');

 const activateAlert = () => {
  setAlertActive(true);
  setTimeout(() => {
   setAlertActive(false);
  }, 3000);
 };

 const handleSubmitOtp = async (e) => {
  try {
   setIsLoading(true)

   if (newEmail.length < 3) {
    throw new Error('Invalid Input Length!')
   }
   const url = `https://w-shop-backend.vercel.app/api/auth/otp?email=${newEmail}`
   const rawResponse = await fetch(url, {
    method: 'GET',
    headers: {
     'Content-type': 'application/json'
    },
   })
   const response = await rawResponse.json();
   if (response.status !== 'success') {
    throw new Error(response.message);
   }
   setOtpToken(response.data.otpToken);
   setIsLoading(false);
  } catch (error) {
   setIsLoading(false);
   setAlert({
    type: 'danger',
    message: 'Error: ' + error.message,
   })
   activateAlert();
  }
 }

 const handleUpdateEmail = async () => {
  setIsLoading(true);
  try {
   const url = 'https://w-shop-backend.vercel.app/api/users/email';
   const response = await fetch(url, {
    method: 'PUT',
    headers: {
     'Content-type': 'application/json',
     'Authorization': 'Bearer ' + cookies.accessToken,
    },
    body: JSON.stringify({ otpToken: otpToken, otp: otp }),
   });
   const body = await response.json();
   if (body.status !== 'success') {
    throw new Error(body.message,);
   } else {
    const event = {
     type: 'alert',
     alert: {
      type: 'success',
      message: 'Update Ticket Data Success',
     }
    };
    setCookie('event', event, { path: '/' });
    setAlert(event.alert)
    activateAlert()
    navigate('/');
    setIsLoading(false)
   }
  } catch (error) {
   setIsLoading(false);
   setAlert({
    type: 'danger',
    message: 'Error: ' + error.message,
   })
   activateAlert();
  }
 }
 return (
  <div className='main'>
   <Alert active={alertActive} type={alert.type} message={alert.message} />
   <LoadingScreen active={isLoading} />
   <div className='container py-5'>
    <div className=' p-5' style={{ backgroundColor: "white" }}>
     <h1 className=' titleProfile'>Ubah Email</h1>
     <hr />
     <div className="mb-3">
      <label className="form-label">Email Lama</label>
      <p>{userData.email}</p>
     </div>
     <div className="mb-3">
      <label className="form-label">Email Baru</label>
      <input type="email" className="form-control" id="nama" onChange={(e) => {
       setNewEmail(e.target.value);
      }} />
     </div>
     <div className="mb-3">
      <label className="form-label">Kode OTP</label>
      <div className=' d-flex'>
       <input type="text" className="form-control d-flex" id="noHp" onChange={(e) => {
        setOtp(e.target.value);
       }} />
       <button className=' btn btn-primary ms-3' style={{ width: '200px' }} onClick={() => { handleSubmitOtp() }}>Kode OTP</button>
      </div>
     </div>
     <button className="btn btn-primary  ms-auto  d-block" style={{ width: '180px', marginTop: '15%', height: '50px' }} onClick={handleUpdateEmail}>Simpan</button>
    </div>
   </div>
  </div>
 );
}
